import { FrameName } from "../config";
import ShallowSeaPearlHunterBuildingTileEntity from "./ShallowSeaPearlHunterBuildingTileEntity";

class DeepSeaPearlHunterBuildingTileEntity extends ShallowSeaPearlHunterBuildingTileEntity {
	public static readonly frameName = FrameName.DEEP_SEA_PEARL_HUNTER;
}

export default DeepSeaPearlHunterBuildingTileEntity;
